export class ApiError extends Error {
  readonly code?: string;
  readonly details?: Record<string, unknown>;
  readonly status: number;

  constructor({
    code,
    details,
    message,
    status,
  }: {
    code?: string;
    details?: Record<string, unknown>;
    message: string;
    status: number;
  }) {
    super(message);
    this.name = 'ApiError';
    this.code = code;
    this.details = details;
    this.status = status;
  }
}
